// src/components/PlatformLayout.js
import React from "react";
import { Box } from "@mui/material";
import SidebarPlatform from "./SideBarPlatform";
import TopBar from "./TopBar";
import RedBackground from "../assets/Banner2.png";
import RedBackground2 from "../assets/Banner2.png";
import { useEffect, useState } from "react";

const COLORS = { bg: "#fff8ff" };
const TOPBAR_H = "60px";

export default function PlatformLayout({
  children,
  modOrAdmin = false,
  userRole   = "moderador",
  hideBanner = false,
  uid        = null,
  userInfo   = null,        // ← nuevo
  ...rest
}) {
  const [mode, setMode] = useState("aspirante");

  useEffect(() => {
    if (!modOrAdmin) setMode("aspirante");
  }, [modOrAdmin]);

  const handleToggleMode = () => {
    if (!modOrAdmin) return;
    setMode(prev => prev === "aspirante" ? "admin" : "aspirante");
  };

  return (
    <Box sx={{ backgroundColor: COLORS.bg, minHeight: "100vh" }}>

      {/* ── TOP BAR institucional (fijo arriba) ── */}
      <TopBar uid={uid} userInfo={userInfo} userRole={userRole} />

      {/* ── SIDEBAR (fijo izquierda, debajo del topbar) ── */}
      <SidebarPlatform
        mode={mode}
        canSwitchMode={modOrAdmin}
        onToggleMode={handleToggleMode}
        userRole={userRole}
        uid={uid}
        topOffset={TOPBAR_H}   // ← nuevo prop para bajar el sidebar
      />

      {/* ── CONTENIDO (desplazado del sidebar + topbar) ── */}
      <Box sx={{ pl: "260px", pt: TOPBAR_H }}>
        {!hideBanner && (
          <Box sx={{
            width: "100%", aspectRatio: "16 / 1.5",
            backgroundImage: `url(${RedBackground})`,
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
          }} />
        )}

        <Box sx={{ px: { xs: 2, md: 4 }, py: 4 }}>
          {children}
        </Box>

        <Box sx={{
          width: "100%", aspectRatio: "16 / 1.5",
          backgroundImage: `url(${RedBackground2})`,
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        }} />
      </Box>
    </Box>
  );
}
